import { useEffect } from 'react';
import HeaderExtra from '../components/HeaderExtra'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/rangeslider.css'
import '../Assets/css/datepicker.css'
import '../Assets/css/paymentform.css'
import '../Assets/css/hoteldetails.css'

import  '../Assets/js/datetimefunc.js'
import  '../Assets/js/hoteldetails.js'
import  '../Assets/js/bookingdetails.js'

function BookingDetails()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("BookingDetails");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderExtra page="Booking Details"/>

        <div className="MainContentSection" id="AllMainContentSection">
          <div className="HotelDetailsHotelImageContainer PaddingLeftRightForSafari" id="HotelDetailsHotelImageContainer">
            <div id="ImagePreviewBackgroundContainer" style={{ display: "none", width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}} >
              <img className="RoomPanelImageBackgroundDisplay" id="ImagePreviewBackground"/>
            </div>
            <div className="loading_grey ImageFullCover RoomPanelImageBackgroundDisplay" id="LoadingImageBackground" />
            <div className="MainSectionBasicWithBlue" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
              <div className="HotelDetailsImageWrapper" id="ImageTopMainWrapper">
                <div className="HotelDetailsHotelImageMain BasicRoundRadius Selectable">
                  <button className="BasicTextButton BasicBoxShadow OrangeButton SeeAllPhotosButton Selectable" id='SeeAllPhotosEarly'>See All Photos</button>
                  <div className="loading_grey ImageFullCover"></div>
                </div>

                <div className="HotelDetailsHotelImageSub">
                  <div className="HotelDetailsHotelImageSubMini2">
                    <div className="loading_grey ImageFullCover"></div>
                  </div>
                  <div className="HotelDetailsHotelImageSubMini2">
                    <div className="loading_grey ImageFullCover"></div>
                  </div>
                </div>

                <div className="HotelDetailsHotelImageSub">
                  <div className="HotelDetailsHotelImageSubMini2">
                    <div className="loading_grey ImageFullCover"></div>
                  </div>
                  <div className="HotelDetailsHotelImageSubMini2">
                    <div className="loading_grey ImageFullCover"></div>
                  </div>
                </div>
              </div>

              <div className="AllImageSwiperContainer">
                <div className="ImageSwiperButtonContainer">
                  <button className="HotelDetailsPhotoPrevButton" id="ImgSwiperPrevButton" style={{ opacity: 0 }}>
                    <img src="/Assets/images/ButtonIcon/white-chevron.svg" />
                  </button>
                </div>

                <div className="MainSwiperContainer swiper-container" id="MiniImageListSwiperContainer">
                  <div className="swiper-wrapper MainImageSwiperWrapper" id="MiniImageListSwiperWrapper">
                    <div className="HotelImageSwiperPanel swiper-slide" style={{ opacity: 0 }}>
                      <div className="loading_grey ImageFullCover"></div>
                    </div>
                    <div className="HotelImageSwiperPanel swiper-slide">
                      <div className="loading_grey ImageFullCover"></div>
                    </div>
                    <div className="HotelImageSwiperPanel swiper-slide">
                      <div className="loading_grey ImageFullCover"></div>
                    </div>
                    <div className="HotelImageSwiperPanel swiper-slide">
                      <div className="loading_grey ImageFullCover"></div>
                    </div>
                  </div>
                </div>

                <div className="ImageSwiperButtonContainer">
                  <button className="HotelDetailsPhotoNextButton" id="ImgSwiperNextButton" style={{ opacity: 0 }}>
                    <img src="/Assets/images/ButtonIcon/white-chevron.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
            <div className="HotelDetailsInformationWrapper">
              <div className="HotelDetailsInformationLeftSection">
                <div className="ContainerWithIconAndText BasicRoundRadius InputFieldMargin3" style={{"background":"#FFFAEB",WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column",display:"none"}} id="SubmitExperienceContainer">
                  <div style={{width:"auto",height:"fit-content",display:"flex"}} className="InputFieldMargin3">
                    <img src="/Assets/images/Icon/three-stars.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft:"0",marginTop:"0",height:"fit-content"}} />
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{"margin":"auto 0","color":"#344054"}} id="YouHaveFinishedBookMesText">You have finished staying at Glamping Bali Riverside, you can share your memorable experiences activities at Glamping Bali Riverside here</p>
                  </div>
                  <button className="BasicTextButton BlueButton SignInButtonTop Selectable" style={{backgroundColor:"#50A9E1",width:"98%",display:"flex",marginLeft:"auto",marginRight:"auto"}} id="SubmitExperienceButton">
                    <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto auto"}}>
                      <img className="BasicIconInsideButton2" src="/Assets/images/ButtonIcon/share-white-icon.svg" />
                      <p id="SubmitExperienceButtonText">Submit Experience</p>
                    </div>
                  </button>
                </div>
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                <div className="HotelDetailsHotelInformationMarginWrapper TextToDisplayAfterCalc" style={{display:"none"}}>
                  <p className="RoomHotelTypeText InterBoldTextFont" id="AccommodationTypeText">Cottage</p>
                  <p className="RoomHotelNameInsidePanel InterBoldTextFont" id="AccommodationNameText">Hotel Name</p>
                </div>
                <div className="SectionHeaderTextIndex RoomHotelNameInsidePanel loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                <div className="HotelDetailsHotelInformationMarginWrapper TextToDisplayAfterCalc" style={{display:"none"}}>
                  <p className="BasicInputTextTop InterRegularTextFont TextToDisplayAfterCalc" id='OrderNumberText'>Order Number: <span className='InterMediumItalicTextFont'>0000-0000</span></p>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper TextToDisplayAfterCalc" style={{display:"none"}}>
                  <img src="/Assets/images/ButtonIcon/location-icon.svg" className="LocationIconInsidePanel" style={{marginLeft:"0"}} />
                  <p className="RoomLocationTextInsidePanel InterMediumTextFont" id="LocationText" style={{whiteSpace:"normal",maxWidth:"100%"}}>Uluwatu, Bali Uluwatu, Bali Uluwatu, Bali - <span className="SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText">See Map</span></p>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper PriceGreyLoading">
                  <div className="RoomSmallInfo loading_grey" />
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper InputFieldMargin2" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                  <div className="HotelDescriptionInsidePanel loading_grey PriceGreyLoading" />
                  <p className="DescriptionTextNotDisableable InterRegularTextFont TextToDisplayAfterCalc" id="RoomDescriptionText" style={{display:"none"}}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam voluptates ullam exercitationem amet quas! Explicabo, laborum accusantium ab, unde possimus officia mollitia veritatis quos officiis enim earum deserunt esse placeat?</p>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper" id="ShareAccommodationButtonWrapper" style={{display:"none"}}>
                  <div className="ContainerWithIconAndText ShareBookingMesButtonContainer BasicRoundRadius">
                    <div style={{width:"fit-content",height:"fit-content",display:"flex"}}>
                      <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="BasicIconInsideOrangeContainer" style={{marginLeft:"0"}} />
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{"margin":"auto 0","color":"white"}} id="DapatkanRefMessageText">Dapatkan referral poin setelah teman kamu menginap</p>
                    </div>
                    <button className="ShareButtonBlue Selectable" id="ShareAccommodationButton">
                      <div style={{display:"flex",margin:"auto", overflow:"hidden"}}>
                        <img src="/Assets/images/ButtonIcon/share-icon-blue.svg" />
                        <p className="InterBoldTextFont" id="ShareAccommodationButtonText" style={{whiteSpace:"nowrap", textOverflow:"ellipsis", width:"100%", overflow:"hidden"}}>Share Accommodation</p>
                      </div>
                    </button>
                  </div>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper SectionSeparatorWithGreyLine InputFieldMargin2" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                  <p className="BasicInputTextBottom InterRegularTextFont TextToDisplayAfterCalc" style={{"color":"#344054",display:"none"}} id="RoomTypeHeaderText">Room type</p>
                  <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{width:"20%"}} />
                  <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{width:"80%"}} />
                  <div className="InputFieldMargin3">
                    <p className="BasicInputTextTop InterMediumTextFont TextToDisplayAfterCalc" style={{marginBottom:"0",display:"none"}} id="RoomNameAndQuantityTexts">1x <span className="InterRegularTextFont">Standard Room - Breakfast</span></p>
                  </div>
                  <div className="BlueColouredBenefits RoomHotelBenefitsInsidePanel TextToDisplayAfterCalc" id="RoomBenefitsContainer" style={{display:"none"}}>
                    <div className="swiper-wrapper">
                      <div className="RoomBenefitsPanel swiper-slide">Hotels</div>
                      <div className="RoomBenefitsPanel swiper-slide">Breakfast Included</div>
                      <div className="RoomBenefitsPanel swiper-slide">Hotels</div>
                      <div className="RoomBenefitsPanel swiper-slide">Breakfast Included</div>
                      <div className="RoomBenefitsPanel swiper-slide">Hotels</div>
                      <div className="RoomBenefitsPanel swiper-slide">Breakfast Included</div>
                    </div>
                  </div>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper InputFieldMargin2">
                  <div className="PriceGreyLoading" style={{WebkitFlex:"1",msFlex:"1",flex:"1",display:"flex"}}>
                    <div style={{width:"15%"}}>
                      <div className="RoomSmallInfo loading_grey" style={{width:"70%"}} />
                      <div className="RoomSmallInfo loading_grey" style={{width:"90%"}} />
                    </div>
                    <div style={{width:"20%","margin":"auto 0"}}>
                      <div className="RoomSmallInfo loading_grey" style={{width:"90%"}} />
                    </div>
                    <div style={{width:"15%"}}>
                      <div className="RoomSmallInfo loading_grey" style={{width:"70%"}} />
                      <div className="RoomSmallInfo loading_grey" style={{width:"90%"}} />
                    </div>
                  </div>
                  <div className="TextToDisplayAfterCalc" style={{display:"none"}}>
                    <p className="BasicInputTextBottom InterRegularTextFont" style={{"color":"#344054"}} id="CheckInHeaderText">Check In</p>
                    <div className="InputFieldMargin3">
                      <p className="BasicInputTextTop InterMediumTextFont" style={{marginBottom:"0"}} id="CheckInDateBookingDetailsText">17 Dec 2023</p>
                    </div>
                  </div>
                  <div className="BluDotWrapper TextToDisplayAfterCalc" style={{display:"none"}}>
                    <div className="BlueNightDotLine" />
                    <p className="SmallerRoomDescriptionText InterRegularTextFont HowManyNightText" style={{"margin":"0 auto"}}>3 Night</p>
                  </div>
                  <div className="TextToDisplayAfterCalc" style={{display:"none"}}>
                    <p className="BasicInputTextBottom InterRegularTextFont" style={{"color":"#344054"}} id="CheckOutHeaderText">Check Out</p>
                    <div className="InputFieldMargin3">
                      <p className="BasicInputTextTop InterMediumTextFont" style={{marginBottom:"0"}} id="CheckOutDateBookingDetailsText">17 Dec 2023</p>
                    </div>
                  </div>
                </div>
                <div className="HotelDetailsHotelInformationMarginWrapper InputFieldMargin2 TextToDisplayAfterCalc" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column",display:"none"}}>
                  <p className="BasicInputTextBottom InterRegularTextFont" id="GuestPaymentHeaderText">Guest</p>
                  <p className="BasicInputTextTop InterBoldTextFont" style={{marginBottom:"0"}} id="GuestNameText">Guest Name</p>
                  <div className="PhoneNumberAndEmailWrapper">
                    <div className="EmailSeparatorWrapper">
                      <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{"color":"rgb(37, 37, 37)"}} id="GuestEmailText">test@gmail.com</p>
                    </div>
                    <div className="GreyLineSeparator" />
                    <div className="PhoneNumberSeparatorWrapper">
                      <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{"color":"rgb(37, 37, 37)"}} id="GuestPhoneNumberText">-----</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="HotelDetailsInformationRightSection RightSectionBookingDetails RightSectionOpen ThisPriceContainerToHideShow ShowDetailsPriceOFF" style={{backgroundColor:"transparent",opacity:1, overflow:"visible", flexDirection:"column"}}>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOn">
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont OriginalPriceHeaderText" style={{"color":"#000000"}}>Original Price</p>
                    <p className="LabelGreyHeaderSmallerText2 InterMediumTextFont HyperlinkUnderlineText HideHyperlinkButtonText" style={{"color":"#ED7C42",marginLeft:"auto"}} onClick={()=> window.HideandDisplayPaymentDetails(true)}>Hide</p>
                  </div>
                  <div className="PriceTextMainContainer OriginalPriceContainer PriceContainerToAddAddOn">
                    <div className="PriceMainTextWrapper">
                      <div className="RoomSmallInfo loading_grey" style={{marginLeft:"0"}} />
                      <div className="Price2ndWrapper">
                        <div className="RoomSmallInfo loading_grey" style={{marginLeft:"auto"}} />
                      </div>
                    </div>
                    <div className="PriceMainTextWrapper">
                      <div className="Price1stWrapper">
                        <p className="LabelGreyHeaderSmallerText InterMediumTextFont">17 Dec 2023</p>
                      </div>
                      <div className="Price2ndWrapper">
                        <p className="LabelGreyHeaderSmallerText InterMediumTextFont">Rp 500,000,00</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOn">
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont YouSavedHeaderText" style={{"color":"#000000"}}>You Saved</p>
                  </div>
                  <div className="PriceTextMainContainer YouSavedContainer" is-one="false">
                    <div className="PriceMainTextWrapper">
                      <div className="RoomSmallInfo loading_grey" style={{marginLeft:"0"}} />
                      <div className="Price2ndWrapper">
                        <div className="RoomSmallInfo loading_grey" style={{marginLeft:"auto"}} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius OriginalPriceToHideOnOff">
                  <div className="InputFieldMargin3 ">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont OriginalPriceHeaderText" style={{"color":"#000000"}}>Original Price</p>
                    <p className="LabelGreyHeaderSmallerText2 InterMediumTextFont HyperlinkUnderlineText SeeDetailsHyperlinkText" style={{"color":"#ED7C42",marginLeft:"auto"}} onClick={()=> window.HideandDisplayPaymentDetails(false)}>See Details</p>
                  </div>
                  <div className="PriceTextMainContainer InputFieldMargin2 PriceContainerToAddAddOn">
                    <div className="PriceMainTextWrapper">
                      <div className="Price1stWrapper">
                        <div className="RoomHotelRightInfo2 loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                        <p className="LabelGreyHeaderSmallerText InterMediumTextFont TextToDisplayAfterCalc HowManyNightText" style={{display:"none"}}>2 Nights</p>
                      </div>
                      <div className="Price2ndWrapper">
                        <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{marginLeft:"auto"}} />
                        <p className="LabelGreyHeaderSmallerText InterExBoldTextFont TextToDisplayAfterCalc OriginalPriceText" style={{display:"none"}} rp-type={1} final-zero="true">Rp 500,000,00</p>
                      </div>
                    </div>
                  </div>
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont YouSavedHeaderText" style={{"color":"#000000"}}>You Saved</p>
                  </div>
                  <div className="PriceTextMainContainer YouSavedContainer" is-one="true">
                    <div className="PriceMainTextWrapper">
                      <div className="RoomSmallInfo loading_grey" style={{marginLeft:"0"}} />
                      <div className="Price2ndWrapper">
                        <div className="RoomSmallInfo loading_grey" style={{marginLeft:"auto"}} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius">
                  <div className="PriceTextMainContainer">
                    <div className="PriceMainTextWrapper">
                      <div className="Price1stWrapper">
                        <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont TotalTextPaymentSection">Total</p>
                      </div>
                      <div className="Price2ndWrapper">
                        <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{marginLeft:"auto"}} />
                        <p className="LabelGreyHeaderSmallerText InterExBoldTextFont TextToDisplayAfterCalc FinalPriceText" style={{display:"none"}} rp-type={1} final-zero="true">Rp 000.000,00</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius">
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont" style={{"color":"#000000",WebkitTextAlign:"end",textAlign:"end",marginLeft:"0"}} id="DownPaymentHeaderText">Down Payment</p>
                  </div>
                  <div className="InputFieldMargin2" style={{WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content",WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                    <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                    <div className="RoomHotelRightInfo2 loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                    <div id="PaymentStatusAndDPWrapper" className="TextToDisplayAfterCalc" style={{display:"none"}}>
                      <div className="BookingStatusBookingDetails InputFieldMargin3" id="DownPaymentStatusContainer">
                        <img className="IconInsideRoundedPanel" src="/Assets/images/ButtonIcon/orange-alert-triangle.svg" />Payment Timeout
                      </div>
                      <div style={{WebkitFlex:"2",msFlex:"2",flex:"2"}} id="DownPaymentInfoContainer">
                        <p className="LabelGreyHeaderSmallerText InterRegularTextFont TextToDisplayAfterCalc DownPaymentPercText" style={{WebkitTextAlign:"start",textAlign:"start",marginLeft:"0"}}>Down Payment (50%)</p>
                        <p className="OriginalPriceBiggerText InterBoldTextFont TextToDisplayAfterCalc DownPaymentText" style={{WebkitTextAlign:"start",textAlign:"start",display:"none"}} rp-type={1} final-zero="true">Rp 000.000</p>
                      </div>
                    </div>
                  </div>
                  <div className="InputFieldMargin3 TextToDisplayAfterCalc" style={{display:"none"}}>
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont" style={{"color":"#000000",WebkitTextAlign:"end",textAlign:"end",marginLeft:"0"}} id="PaymentMethodHeaderText">Payment Method</p>
                  </div>
                  <div className="InputFieldMargin2" style={{marginBottom:"0",display:"none"}} id="PaymentInfoWrapper">
                    <div className='PaymentImageContainer ThisPaymentMethodIcon' id='PaymentMethodNormalContainer'>
                      <img className="ImageFullCover" id="PaymetMethodIcon" />
                    </div>
                    <div className='PaymentImageMoreThanOne ThisPaymentMethodIcon' id='PaymentMethodCardContainer' style={{display: 'none'}}>
                      <div className='PaymentImageContainer' style={{backgroundColor:"#FFFFFF", outline:0, marginLeft:0}}>
                        <img src="/Assets/images/PaymentMethod/MasterCard.svg" className="PaymentImageNotCoverAll" style={{width: "100%"}} />
                      </div>
                      <div className='PaymentImageContainer' style={{backgroundColor:"#FFFFFF", outline:0}}>
                        <img src="/Assets/images/PaymentMethod/Visa.png" className="PaymentImageNotCoverAll" />
                      </div>
                    </div>
                    <div className="ThisPriceInfoContainer" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
                      <p className="LabelGreyHeaderSmallerText InterMediumTextFont" id="PaymetMethodText">blu by BCA DIgital (In-App)</p>
                      <p className="SmallerRoomDescriptionText InterRegularTextFont" style={{display:"none","color":"#252525"}} id="PaymentVAText">62165055768</p>
                    </div>
                    <button className="BasicTextButton OrangeButton SignInButtonTop Selectable" style={{"margin":"auto 0",display:"none"}} id="ButtonNextToPayment">
                      <p className='HideOnMobile2' id='ButtonNextToPaymentTextDesktop'>Copy VA</p>
                      <p className='ShowOnMobile2' id='ButtonNextToPaymentTextMobile'></p>
                    </button>
                  </div>
                  <div className="InputFieldMargin2 TwoSeparatorWrapper" style={{marginBottom:"0",display:"none"}} id="NoPaymentSelectedWrapper">
                    <p className="LabelGreyHeaderSmallerText InterMediumTextFont" style={{"margin":"auto 0",WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content"}} id="NoPaymentMethodText">No Payment Method Selected</p>
                    <button className="BasicTextButton OrangeButton SignInButtonTop Selectable" style={{"margin":"auto 0"}} id="SelectAndPayButton">Select and Pay</button>
                  </div>
                </div>
                <div className="GreyContainerInfoPadding AllContentMarginPayment BasicRoundRadius">
                  <div className="InputFieldMargin3" id="CheckedInBookingCompleteLabel" style={{display:"none"}}>
                    <div className="BookingStatusBookingDetails" id="CheckedInBookingCompleteLabelBorder" style={{backgroundColor:"#D3EAF7",marginRight:"0px"}}>
                      <p style={{"color":"#3A9FDD"}} id="CheckedInBookingCompleteLabelText">CheckedIn</p>
                    </div>
                  </div>
                  <div className="InputFieldMargin3">
                    <p className="LabelGreyHeaderSmallerText2 InterBoldTextFont PayAtHotelTextPaymentSection" style={{"color":"#000000",WebkitTextAlign:"end",textAlign:"end",marginLeft:"0"}}>Pay at Hotel</p>
                  </div>
                  <div style={{WebkitFlex:"1",msFlex:"1",flex:"1",height:"fit-content",display:"flex"}}>
                    <div style={{WebkitFlex:"1",msFlex:"1",flex:"1",display:"flex"}}>
                      <div style={{WebkitFlex:"1",msFlex:"1",flex:"1"}}>
                        <div className="RoomHotelRightInfo2 loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                        <div className="RoomSmallInfo loading_grey PriceGreyLoading" style={{marginLeft:"0"}} />
                        <p className="LabelGreyHeaderSmallerText InterRegularTextFont TextToDisplayAfterCalc" style={{WebkitTextAlign:"start",textAlign:"start",marginLeft:"0",display:"none"}} id="RemainingAmountHeaderText">Remaining Amount</p>
                        <p className="OriginalPriceBiggerText InterBoldTextFont TextToDisplayAfterCalc PayAtHotelPriceText" style={{WebkitTextAlign:"start",textAlign:"start",display:"none"}} rp-type={1} final-zero="true">Rp 000.000</p>
                      </div>
                      <div className="BookingStatusBookingDetails" id="PaidPayAtHotelBorder" style={{backgroundColor:"#ECFDF3",margin:"auto",marginRight:"0",display:"none"}}>
                        <p style={{"color":"#027A48"}} id="PaidPayAtHotelText">Sudah Dibayar</p>
                      </div>
                    </div>
                    <div style={{width:"fit-content","margin":"auto 0",marginLeft:"auto",display:"none"}} id="ButtonRefreshPageContainer">
                      <button className="BasicTextButton OrangeButton SignInButtonTop Selectable" onClick={()=> window.location.reload()}>
                        <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto 0"}}>
                          <img src="/Assets/images/ButtonIcon/retry-restart-white.svg" className="BasicIconInsideButton2" style={{marginLeft:"0"}} />
                          <p>Refresh</p>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="SectionSeparatorContainer PingExprezyBookingDetails BasicRoundRadius" id="PingExprezyMainContainer" style={{display:"none"}}>
              <div className="SectionContentWrapper">
                <div className="PingExprezyHeaderButtonWrapper">
                  <p className="SectionHeaderTextIndex LabelGreyHeaderBiggerText InterBoldTextFont" id="PingExprezyHeaderText">Your Experience at This Accommodation</p>
                  <button className="BasicTextButton OrangeButton SignInButtonTop Selectable" style={{"margin":"auto"}} id="ViewMoreExperiencesButtonText">
                    <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto 0"}}>
                      <img className="BasicIconInsideButton2 SendPaperPlaneBtnIconWhite" style={{marginLeft:"0"}} />
                      <p id="ViewMoreExperiencesButtonTextP">View Ping Exprezy</p>
                    </div>
                  </button>
                </div>
                <div className="BasicPanelSwiperMainContainer">
                  <div className="ContainerWithMaskEdge">
                    <div className="HotelRoomPanelSwiperContainer TrendingHotelsSwiperContainer" id="PingExprezySwiperContainer">
                      <div className="swiper-wrapper BasicHotelListPanelSwiperWrapper" id="PingExprezyWrapper">
                        <div className="PingExprezyPanel InterMediumTextFont Selectable swiper-slide">
                          <div className="PingExprezyImageContainer">
                            <img src="/Assets/images/AnimateBG/1.jpg" className="ImageFullCover" />
                            <div className="RatingPingExprezyContainer">
                              <img src="/Assets/images/ButtonIcon/star-fill.svg" />
                              <p className="RatingPingExprezyRatingText RobotoBoldTextFont" style={{"color":"#2494D9"}}>4.5</p>
                              <p className="RatingPingExprezyRatingText RobotoTextFont">/5</p>
                            </div>
                          </div>
                          <div className="PingExprezyDescriptionContainer">
                            <div className="PingExperienceDescriptionText">
                              <p className="RoomHotelDescriptionInsidePanel InterRegularTextFont" style={{"color":"#344054"}}>Test Description Test Description Test Description</p>
                            </div>
                            <div className="PingExprezyUserInfoWrapper">
                              <img src="/Assets/images/LogoIcon.svg" className="PingExprezyUserProfileIcon" />
                              <div className="PingExprezyUserNameLocationWrapper">
                                <p className="LabelGreyHeaderSmallerText InterBoldTextFont">Nathan A</p>
                                <p className="LabelGreyHeaderSmallerText InterRegularTextFont" style={{"color":"#1D2939"}}>Uluwatu, Bali</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="PingExprezyPanel InterMediumTextFont Selectable swiper-slide" style={{pointerEvents:"none"}}>
                          <div className="PingExprezyImageContainer">
                            <div className="loading_grey ImageFullCover" />
                          </div>
                          <div className="PingExprezyDescriptionContainer">
                            <div className="RoomSmallInfo loading_grey" />
                            <div className="RoomHotelRightInfo2 loading_grey" style={{marginLeft:"0"}} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="PopularAreasLeftRightButtonContainer PaddingButtonLeft">
                    <button className="NextPreviousSwiperButton Selectable2 TrendingHotelLeft" id="ExprezyButtonLeft">
                      <img src="/Assets/images/ButtonIcon/chevron.svg" />
                    </button>
                  </div>
                  <div className="PopularAreasLeftRightButtonContainer PaddingButtonRight">
                    <button className="NextPreviousSwiperButton Selectable2 TrendingHotelRight swiper-button-disabled" id="ExprezyButtonRight">
                      <img src="/Assets/images/ButtonIcon/chevron.svg" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="MainContentSection" id="BookingNotFoundContainer" style={{display:"none"}}>
            <div className="MainSectionBasicWithBlue" style={{WebkitFlexDirection:"column",msFlexDirection:"column",flexDirection:"column"}}>
              <div className="VoucherDetailsContentWrapper">
                <div className="NoFeaturedPropertyFoundContainer NotFoundWrapper">
                  <img src="/Assets/images/Icon/NoVoucherFound.svg" className="NoFoundIcon InputFieldMargin3" />
                  <p className="NoFoundHeaderText InterBoldTextFont" id="BookingNotFoundHeader">Booking Details Not Found</p>
                  <p className="NoFoundMessageText InterRegularTextFont" style={{width:"85%"}} id="BookingNotFoundMessage">We couldn't find any booking details for your request. Please check your booking ID or try again later.</p>
                </div>
              </div>
            </div>
          </div>

      </div>

      <RightPanelMobile/>
      
      <Footer/>
    </>
  )
}

export default BookingDetails